import Card from '@/components/Card';
import { optimizeImageUrl } from '@/utils/media/optimizeImageUrl';
import getPresetPreviews from '@/utils/preset/getPresetPreviews';
import { PreviewMediaType } from '@/types';

import type { PresetCardCardProps } from './types';

/**
 * Preset tile for the mobile grid. Deliberately action-free — the grid is for
 * browsing, and Like / Save both live in the preset feed a tap away, where
 * there is room to label them.
 */
const PresetCard = ({
  item,
  onClick,
  muteButtonPlacement,
  isSelected,
  videoLoadDelay,
}: PresetCardCardProps) => {
  const isVideo = item.type === PreviewMediaType.VIDEO;

  return (
    <Card
      dataTestId={`preset-card-${item.slug}`}
      imageUrl={optimizeImageUrl(item.media.url)}
      previews={getPresetPreviews({ item })}
      title={item.title}
      description={item.description}
      isVideo={isVideo}
      poster={optimizeImageUrl(item.media.poster)}
      onClick={onClick}
      showHoverOverlay
      hideVideoIcon
      owner={item.owner}
      showMuteButton={isVideo}
      muteButtonPlacement={muteButtonPlacement}
      isSelected={isSelected}
      videoLoadDelay={videoLoadDelay}
      fillHeight
    />
  );
};

export default PresetCard;
